import TopBar from "./components/TopBar";
import UpdateTicker from "./components/UpdateTicker";
import Hero from "./components/Hero";
import DailyHot from "./components/DailyHot";
import HotRank from "./components/HotRank";
import RecentZones from "./components/RecentZones";
import LiveFeed from "./components/LiveFeed";
import CommentTalk from "./components/CommentTalk";
import SubscribeBar from "./components/SubscribeBar";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <TopBar />
      <UpdateTicker />
      <Hero />
      <DailyHot />
      <HotRank />
      <RecentZones />
      <LiveFeed />
      <CommentTalk />
      <SubscribeBar />
      <Footer />
    </main>
  );
}